module.exports = __webpack_public_path__ + "2e04d9d5fc168eddc11dbf66fa55b3c3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-9.png
// module id = 3020
// module chunks = 0